<template>
	<ActionCard
		size="large"
		theme="dark"
		show-shape
		vertical
		hide-icon-wrapper
		clickable
		class="cursor-default! rounded-2xl!"
		content-class="gap-0.5!"
		card-class="gap-6!"
		header-class="gap-0.5!"
	>
		<template #icon>
			<img :src="patientShape" alt="" class="size-12" width="48" height="48" />
		</template>
		<template #title>
			<div class="text-lg">{{ $t(`dashboard.add_patient_hero_title`) }}</div>
		</template>
		<template #description>
			<div class="text-sm leading-tight">{{ $t(`dashboard.add_patient_hero_description`) }}</div>
		</template>
		<template #extra>
			<JMButton
				type="primary"
				:label="$t(`dashboard.create_new_patient`)"
				icon-placement="right"
				icon-name="carbon:face-add"
				:icon-size="18"
				@click.stop="routePatients({ patientId: 'create' }).navigate()"
			/>
		</template>
	</ActionCard>
</template>

<script setup lang="ts">
import patientShape from "@/assets/images/patient-shape.svg?url"
import ActionCard from "@/components/common/ActionCard.vue"
import JMButton from "@/components/common/JMButton.vue"
import { useNavigation } from "@/composables/router/useNavigation"

const { routePatients } = useNavigation()
</script>
